import { Component } from '@angular/core';
import { IconComponent } from '../../components/icon/icon.component';

interface NotificationItem {
  id: number;
  title: string;
  time: string;
  unread: boolean;
  selected?: boolean;
}

@Component({
  selector: 'l-notifications-modal',
  standalone: true,
  templateUrl: './notifications-modal.component.html',
  imports: [
    IconComponent,
  ]
})
export class NotificationsModalComponent {

  public readonly notifications: NotificationItem[] = [
    {
      id: 1,
      title: NotificationsModalComponent.DEFAULT_NOTIFICATION_TITLE,
      time: '1m ago.',
      unread: true,
    },
    {
      id: 2,
      title: NotificationsModalComponent.DEFAULT_NOTIFICATION_TITLE,
      time: '1m ago.',
      unread: true,
    },
    {
      id: 3,
      title: NotificationsModalComponent.DEFAULT_NOTIFICATION_TITLE,
      time: '1m ago.',
      unread: true,
    },
    {
      id: 4,
      title: NotificationsModalComponent.DEFAULT_NOTIFICATION_TITLE,
      time: '1m ago.',
      unread: false,
    },
  ];

  private static readonly DEFAULT_NOTIFICATION_TITLE = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.';

}
